// extracted by css-extract-rspack-plugin
export default {"pillar":"ContentfulIntroPillars-module__pillar__kvZtA0K"};